import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { searchService } from '../../../utilitiesService/SearchService';

import {
  searchItineraryRequest,
  searchItinerarySuccess,
  searchItineraryFailure,
  searchExcursionsRequest,
  searchExcursionsSuccess,
  searchExcursionsFailure,
  searchCruiseRequest,
  searchCruiseRequestAir,
  searchCruiseSuccess,
  searchCruiseFailure,
  searchCabinAndDatesRequest,
  searchCabinAndDatesRequestAir,
  searchCabinAndDatesSuccess,
  searchCabinAndDatesFailure,
  searchItineraryButtonRequest,
  searchItineraryButtonSuccess,
  searchItineraryMultifilterRequest,
  searchItineraryMultifilterSuccess,
  searchFacetsRequest,
  searchFacetSuccess,
  searchMultipleCabinAndDatesRequest,
  searchMultipleCabinAndDatesRequestAir,
  searchMultipleCabinAndDatesSuccess,
  searchMultipleCabinAndDatesFailure,
  searchCruiseSuccessAir,
  searchCruiseFailureAir,
  searchCabinAndDatesSuccessAir,
  searchCabinAndDatesFailureAir,
  searchMultipleCabinAndDatesSuccessAir,
  searchMultipleCabinAndDatesFailureAir,
  searchExcursionsButtonRequest,
  searchExcursionsButtonSuccess,
} from '../../slices/searchSlice';

export const searchItineraryEpic = (action$: any) =>
  action$.pipe(
    ofType(searchItineraryRequest.type),
    mergeMap((action: { payload: any }) =>
      from(searchService.performSearchItineraries(action.payload)).pipe(
        map((response) => searchItinerarySuccess(response)),
        catchError((error) => of(searchItineraryFailure(error.message)))
      )
    )
  );

export const searchExcursionsEpic = (action$: any) =>
  action$.pipe(
    ofType(searchExcursionsRequest.type),
    mergeMap((action: { payload: any }) =>
      from(searchService.performSearchExcursions(action.payload)).pipe(
        map((response) => searchExcursionsSuccess(response)),
        catchError((error) => of(searchExcursionsFailure(error.message)))
      )
    )
  );

export const searchItineraryButtonEpic = (action$: any) =>
  action$.pipe(
    ofType(searchItineraryButtonRequest.type),
    mergeMap((action: { payload: any }) =>
      from(searchService.performSearchItineraries(action.payload)).pipe(
        map((response) => searchItineraryButtonSuccess(response)),
        catchError((error) => of(searchItineraryFailure(error.message)))
      )
    )
  );

export const searchExcursionsButtonEpic = (action$: any) =>
  action$.pipe(
    ofType(searchExcursionsButtonRequest.type),
    mergeMap((action: { payload: any }) =>
      from(searchService.performSearchExcursions(action.payload)).pipe(
        map((response) => searchExcursionsButtonSuccess(response)),
        catchError((error) => of(searchExcursionsFailure(error.message)))
      )
    )
  );

export const searchMultifilterEpic = (action$: any) => {
  return action$.pipe(
    ofType(searchItineraryMultifilterRequest.type),
    mergeMap((action: { payload: any }) =>
      from(searchService.performSearchMultipleQueries(action.payload)).pipe(
        map((response) => searchItineraryMultifilterSuccess(response)),
        catchError((error) => of(searchItineraryFailure(error.message)))
      )
    )
  );
};

export const searchCruiseEpic = (action$: any) =>
  action$.pipe(
    ofType(searchCruiseRequest.type),
    mergeMap((action: { payload: any }) =>
      from(searchService.performSearchCruises(action.payload)).pipe(
        map((response) => searchCruiseSuccess(response)),
        catchError((error) => of(searchCruiseFailure(error.message)))
      )
    )
  );

export const searchCruiseEpicAir = (action$: any) =>
  action$.pipe(
    ofType(searchCruiseRequestAir.type),
    mergeMap((action: { payload: any }) =>
      from(searchService.performSearchCruisesAir(action.payload)).pipe(
        map((response) => searchCruiseSuccessAir(response)),
        catchError((error) => of(searchCruiseFailureAir(error.message)))
      )
    )
  );

export const searchCabinAndDatesEpic = (action$: any) =>
  action$.pipe(
    ofType(searchCabinAndDatesRequest.type),
    mergeMap((action: { payload: any }) =>
      from(searchService.performSearchCabinsAndDatesLayer(action.payload)).pipe(
        map((response) => searchCabinAndDatesSuccess(response)),
        catchError((error) => of(searchCabinAndDatesFailure(error.message)))
      )
    )
  );

export const searchCabinAndDatesEpicAir = (action$: any) =>
  action$.pipe(
    ofType(searchCabinAndDatesRequestAir.type),
    mergeMap((action: { payload: any }) =>
      from(searchService.performSearchCabinsAndDatesLayerAir(action.payload)).pipe(
        map((response) => searchCabinAndDatesSuccessAir(response)),
        catchError((error) => of(searchCabinAndDatesFailureAir(error.message)))
      )
    )
  );

export const searchFacetsEpic = (action$: any) =>
  action$.pipe(
    ofType(searchFacetsRequest.type),
    mergeMap((action: { payload: any }) =>
      from(searchService.performSearchItineraries(action.payload)).pipe(
        map((response) => searchFacetSuccess(response)),
        catchError((error) => of(searchItineraryFailure(error.message)))
      )
    )
  );

export const searchMultipleCabinsAndDatesEpic = (action$: any) => {
  return action$.pipe(
    ofType(searchMultipleCabinAndDatesRequest.type),
    mergeMap((action: { payload: any }) =>
      from(searchService.performSearchMultipleQueries(action.payload)).pipe(
        map((response) => searchMultipleCabinAndDatesSuccess(response)),
        catchError((error) => of(searchMultipleCabinAndDatesFailure(error.message)))
      )
    )
  );
};

export const searchMultipleCabinsAndDatesEpicAir = (action$: any) => {
  return action$.pipe(
    ofType(searchMultipleCabinAndDatesRequestAir.type),
    mergeMap((action: { payload: any }) =>
      from(searchService.performSearchMultipleQueriesAir(action.payload)).pipe(
        map((response) => searchMultipleCabinAndDatesSuccessAir(response)),
        catchError((error) => of(searchMultipleCabinAndDatesFailureAir(error.message)))
      )
    )
  );
};
